import Vue from 'vue'
import AppAutosizeTextarea from '../../../components/AppAutosizeTextarea'
import AppAccidentService from '../../../components/AppAccidentService'

import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import '../../../../../sass/common/element-variables.scss'
import ElementUIHelper from '../../../element-ui-helper'
import draggable from 'vuedraggable'

locale.use(lang)

Vue.component("app-autoresize-textarea", AppAutosizeTextarea)
Vue.component("app-accident-field", AppAccidentService)

export default (data) => {

    const vm = new Vue({
        el: '#accident-content',
        components: {
            'draggable': draggable,
        },
        data: data,
        methods: {
            addService: function (index) {
                this.$set(this.accidents, this.accidents.length,
                    [{
                        category_id: this.next_category_id(index),
                        accident_id: this.next_id(index, 'accident_id'),
                        category_name: '',
                        category_description: '',
                        sort_no: 1,
                        public_flg: 0,
                        accident_contact_name: '',
                        accident_contact_type: '',
                        accident_tel: '',
                        accident_link_flg: 0,
                        accident_link: '',
                        accident_notes: '',
                        item_public_flg: 0,
                    }]);
                this.$set(this.categories, this.categories.length,
                    {
                        id: this.next_category_id(index),
                        name: '',
                        description: '',
                    });
            },
            addServiceItem: function (index) {
                this.accidents[index].push(
                    {
                        category_id: this.get_category_id(index),
                        accident_id: this.next_id(index, 'accident_id'),
                        sort_no: this.next_id(index, 'sort_no'),
                        public_flg: 0,
                        accident_contact_name: '',
                        accident_contact_type: '',
                        accident_tel: '',
                        accident_link_flg: 0,
                        accident_link: '',
                        accident_notes: '',
                        item_public_flg: 0,
                    });
                this.$set(this.accidents, index, this.accidents[index]);
            },
            deleteService(delete_key, modal_id) {
                this.reset_errors(this.categories[delete_key].id);
                const modal = $(modal_id);
                
                // 削除処理
                this.$delete(this.accidents, delete_key);
                this.$delete(this.categories, delete_key);
                
                // Vue.jsのDOM更新を待つ
                this.$nextTick(() => {
                    // モーダルを閉じる
                    modal.modal('hide');
                    
                    // モーダルが完全に閉じられたことを確認
                    modal.one('hidden.bs.modal', () => {
                        // バックドロップが残っている場合は削除
                        $('.modal-backdrop').remove();
                        // bodyのクラスとスタイルを削除
                        $('body').removeClass('modal-open');
                        $('body').css('padding-right', '');
                    });
                });
            },
            deleteServiceItem: function (index, delete_key, modal_id) {
                this.reset_accident_errors(this.categories[index].id, this.accidents[index][delete_key].accident_id);
                const modal = $(modal_id);
                
                // 削除処理
                this.accidents[index].splice(delete_key, 1);
                this.$set(this.accidents, index, this.accidents[index]);
                
                // Vue.jsのDOM更新を待つ
                this.$nextTick(() => {
                    // モーダルを閉じる
                    modal.modal('hide');
                    
                    // モーダルが完全に閉じられたことを確認
                    modal.one('hidden.bs.modal', () => {
                        // バックドロップが残っている場合は削除
                        $('.modal-backdrop').remove();
                        // bodyのクラスとスタイルを削除
                        $('body').removeClass('modal-open');
                        $('body').css('padding-right', '');
                    });
                });
            },
            draggableEnd: function (index) {
                Object.keys(this.accidents).map(function () {
                    this.accidents[index].map(function (accident, key) {
                        this.reset_accident_errors(accident['category_id'], accident['accident_id']);
                        accident['sort_no'] = accident['accident_id'] = key + 1;
                        return accident;
                    }.bind(this), index);
                }.bind(this), index);
            },
            reset_errors: function (category_id) {
                if ('category_errors' in this.errors) {
                    this.$set(this.errors.category_errors.name, category_id, '');
                }
                if ('accident_errors' in this.errors) {
                    this.$set(this.errors.accident_errors.accident_contact_name, category_id, []);
                }
            },
            reset_accident_errors: function (category_id, accident_id) {
                if ('accident_errors' in this.errors) {
                    this.$set(this.errors.accident_errors.accident_contact_name[category_id], accident_id, '');
                }
            },
            onChangePageOpen(event) {
                this.modal = $('#dialog_publish');
                this.modal.modal('show');
              },
            modalCancel(event) {
                this.modal = $('#dialog_publish');
                if (this.accident_is_open.accident_public_flg) {
                    this.accident_is_open.accident_public_flg = false;
                } else {
                    this.accident_is_open.accident_public_flg = true;
                }
                this.modal.modal('hide');
            },
            modalSettings(event) {
                this.modal = $('#dialog_publish');
                this.modal.modal('hide');
            },
        },
        computed: {
            option: function () {
                return function (index) {
                    return {
                        animation: 100,
                        handle: '.drag_handle',
                        ghostClass: 'ghost',
                        group: {
                            name: 'accident',
                            pull: (this.accidents[index].length > 1),
                            put: (this.accidents[index].length < 9)
                        }
                    };
                }
            },
            next_id: function () {
                return function (index, id_name) {
                    let next_id = (this.accidents[index].length <= 1) ?
                        this.accidents[index][0][id_name] :
                        this.accidents[index].reduce((a, b) => a[id_name] > b[id_name] ? a : b)[id_name];
                    let parsed_id = parseInt(next_id);
                    if (isNaN(parsed_id) || parsed_id === undefined || parsed_id === null) {
                        parsed_id = 0;
                    }
                    return parsed_id + 1;
                }
            },
            next_category_id: function () {
                return function (index) {
                    return parseInt(this.accidents[index][0].category_id) + 1;
                }
            },
            get_category_id: function () {
                return function (index) {
                    return this.accidents[index][0]['category_id'];
                }
            },
        }
    });
}
